export const LOADING = 'theme/LOADING';
export const CHANGE_BASE_THEME = 'theme/CHANGE_BASE_THEME';
export const CHANGE_COLOR_THEME = 'theme/CHANGE_COLOR_THEME';